<i18n lang="yaml">
  fr:
    share-twitter: Partager sur Twitter
    share-facebook: Partager sur Facebook
</i18n>

<template>
  <page-section v-if="content">

    <default-hero
      :title="coloredTitle"
      description=""
      image="" />

    <div class="grid space-pb-10--xxs">
      <div class="grid__row">
        <!-- eslint-disable-next-line max-len -->
        <div
          class="
            grid__col-12--xxs
            grid__col-8--s
            grid__push-2--s
          ">
          <wysiwyg>
            <!-- eslint-disable vue/no-v-html -->
             <nuxt-content :document="content" />
          </wysiwyg>

          <!-- Social share buttons -->
          <div class="type-align-center" v-if="showSocialSharing">
            <a id="share-twitter" href="#" target="_blank">
              <span class="btn btn--secondary btn--width-full-xxs btn--width-auto-xs space-mx-1 space-mb-1--xxs">
                <icon
                    name="icon-twitter"
                    width="24"
                    height="24"
                    class="space-mr-1"
                  />
                {{ $t('share-twitter') }}
              </span>
            </a>

            <a id="share-facebook" href="#" target="_blank">
              <span class="btn btn--secondary btn--width-full-xxs btn--width-auto-xs space-mx-1">
                <icon
                    name="icon-facebook"
                    width="24"
                    height="24"
                    class="space-mr-1"
                  />
                {{ $t('share-facebook') }}
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </page-section>
</template>

<script>
  import Wysiwyg from '~/components/Wysiwyg';
  import DefaultHero from '~/components/DefaultHero';
  import PageSection from '~/components/CMS/PageSection';
  import Icon from '~/components/Icon';

  export default {
    components: {
      Wysiwyg,
      DefaultHero,
      PageSection,
      Icon,
    },

    head() {
      return {
        title: 'Ween | ' + this.content.title,
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.metaDescription,
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: this.metaKeywords,
          },
        ],
      };
    },

    created() {
      if (this.showSocialSharing === undefined)
        this.showSocialSharing = false;
    },

    mounted() {
      if (this.showSocialSharing) {
        const title = this.content.title;

        // Twitter
        let url = new URL('https://twitter.com/intent/tweet');
        url.searchParams.set('text', title);
        url.searchParams.set('url', window.location);
        url.searchParams.set('via', 'Ween_Home');
        document.getElementById('share-twitter').href = url;

        // Facebook
        url = new URL('https://www.facebook.com/sharer/sharer.php');
        url.searchParams.set('u', window.location);
        document.getElementById('share-facebook').href = url;
      }
    },

    computed: {
      coloredTitle() {
        const [ firstWord, ...otherWords ] = this.content.title.split(' ');
        // eslint-disable-next-line max-len
        return `<span class="color-green">${firstWord}</span> ${otherWords.join(' ')}`;
      },
    },
  };
</script>
